import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
export const navigationItemContainerStyles = ({ $anyIsActive, $isActive, }) => css `
	display: ${!$anyIsActive || $isActive ? 'flex' : 'none'};
	flex-direction: column;
	cursor: pointer;
	line-height: 1.6;

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		display: flex;
	}
`;
export const NavigationItemContainer = styled.li `
	${navigationItemContainerStyles}
`;
